import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    totalUsers: "",
    totalMonthWiseUsers: [],
    totalFaqs: "",
    totalMonthWiseFaqs: [],
    TotalJobsApp: "",
    TotalJobs: "",
    hipConstentGrantLog: [],
    totalHipConstentGrantLog: "",
    totalHipConstentGrantLog: "",
    hipDataRequestLog: [],
    hipAuthConfirmLog: [],
    abdmHipLog: [],
    UserInisited: [],
    constentRequestLog: [],
    hiuConsentArtifactRequested: [],
    totalhiuConsentArtifactRequested: '',
    CconsentGrantLogs: [],
    totalCconsentGrantLogs: '',
    ConsentArtifactDetails: [],
    totalConsentArtifactDetails: '',
    HelathInformationRequested: [],
    totalhipDataRequestLog: "",
    DataRequestSentLogs: [],
    totalDataRequestSentLogs: '',
    DataPendingLogs: [],
    totalDataPendingLogs: '',
    patientAbhaCardsLogs: [],
    dashboardCounts: {},
    dashboardLInkedCounts: {},
    HiudashboardCounts: {},
    hipDataShared: [],
    totalhiuDataShared: '',
    HiuDataRequest: [],
    totalHiuDataRequest: '',
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setUsersCount: (state, action) => {
            state.totalUsers = action.payload ?.TotalUsers;
            state.totalMonthWiseUsers = action.payload ?.TotalMonthWiseUsers;
        },
        setFaqsCount: (state, action) => {
            state.totalFaqs = action.payload ?.TotalFaqs;
            state.totalMonthWiseFaqs = action.payload ?.TotalMonthWiseFaqs;
        },
        setJobAddCount: (state, action) => {
            state.TotalJobs = action.payload ?.TotalJobs;
        },
        setJobAppCount: (state, action) => {
            state.TotalJobsApp = action.payload ?.TotalJobs;
        },
        setHipAuthConfirmLog: (state, action) => {
            state.hipAuthConfirmLog = action.payload;
        },
        setHipConstentGrantLog: (state, action) => {
            state.hipConstentGrantLog = action.payload.list;
            state.totalHipConstentGrantLog = action.payload.dataLength;

        },
        setHipDataRequestLog: (state, action) => {
            state.hipDataRequestLog = action.payload.list;
            state.totalhipDataRequestLog = action.payload.dataLength;
        },
        setAbdmHipLog: (state, action) => {
            state.abdmHipLog = action.payload.result;
            state.totalAbhaCardsLogs = action.payload.dataLength
        },
        setUserInisited: (state, action) => {
            state.UserInisited = action.payload;
        },
        setConstentRequestLog: (state, action) => {
            state.constentRequestLog = action.payload;
        },
        sethiuConsentArtifactRequested: (state, action) => {
            state.hiuConsentArtifactRequested = action.payload.list;
            state.totalhiuConsentArtifactRequested = action.payload.dataLength;
        },
        setCconsentGrantLogs: (state, action) => {
            state.CconsentGrantLogs = action.payload.list;
            state.totalCconsentGrantLogs = action.payload.dataLength;
        },
        setConsentArtifactDetails: (state, action) => {
            state.ConsentArtifactDetails = action.payload.list;
            state.totalConsentArtifactDetails = action.payload.dataLength;
        },
        setHelathInformationRequested: (state, action) => {
            state.HelathInformationRequested = action.payload;
        },
        setDataRequestSentLogs: (state, action) => {
            state.DataRequestSentLogs = action.payload.list;
            state.totalDataRequestSentLogs = action.payload.dataLength;
        },
        setDataPendingLogs: (state, action) => {
            state.DataPendingLogs = action.payload.list;
            state.totalDataPendingLogs = action.payload.dataLength;
        },
        setpatientAbhaCardsLogs: (state, action) => {
            state.patientAbhaCardsLogs = action.payload;
        },
        setDashboardCounts: (state, action) => {
            state.dashboardCounts = action.payload;
        },
        setDashboardLinked: (state, action) => {
            state.dashboardLInkedCounts = action.payload;
        },
        setHiuDashboardCounts: (state, action) => {
            state.HiudashboardCounts = action.payload;
        },
        setDataSharedHip: (state, action) => {
            state.hipDataShared = action.payload.list;
            state.totalhiuDataShared = action.payload.dataLength;
        },
        setHiuDataRequest: (state, action) => {
            state.HiuDataRequest = action.payload.list;
            state.totalHiuDataRequest = action.payload.dataLength;
        },
    },
})

export const { setDashboardCounts, setUsersCount, setFaqsCount, setJobAppCount, setJobAddCount, setConstentRequestLog, setHipAuthConfirmLog, setHipConstentGrantLog, setHipDataRequestLog, sethiuConsentArtifactRequested, setAbdmHipLog, setCconsentGrantLogs, setConsentArtifactDetails, setHelathInformationRequested, setDataRequestSentLogs, setpatientAbhaCardsLogs, setHiuDashboardCounts, setDataSharedHip, setHiuDataRequest, setDataPendingLogs, setUserInisited,setDashboardLinked } = dashboardSlice.actions

export default dashboardSlice.reducer